/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { EventEmitter, ViewContainerRef } from '@angular/core';
import { FilterMetadata } from '@irian-ro/abstract-resource';
import { FilterComponentFactory } from '@irian-ro/table-column-filter';
import { FilterMatchMode } from 'primeng/api';
import { MultiselectFilterComponent } from './multiselect-filter/multiselect-filter.component';

export interface InputOptions{
  props?: {
    options: string[];
    value: string[];
  };
  filterMatchMode?: string;
  filterChangeEvent?: EventEmitter<FilterMetadata>;

}
export const multiselectFilterFactory: FilterComponentFactory<MultiselectFilterComponent> = {
  createInstance: (container: ViewContainerRef) => {
    return container.createComponent<MultiselectFilterComponent>(MultiselectFilterComponent).instance;
  },

  bindProps: (instance: MultiselectFilterComponent, options?: InputOptions) => {
    instance.options.set(options?.props?.options ? options?.props?.options : []);
    instance.value.set(options?.props?.value ? options.props.value : []);
    instance.filterMatchMode.set(options?.filterMatchMode ? options?.filterMatchMode : FilterMatchMode.IN);
  },

  subscribeToChanges: (instance: MultiselectFilterComponent, options?: InputOptions) => {
    instance.filtersChange.subscribe((filterMetadata: FilterMetadata) => {
      if (options?.filterChangeEvent) {
        options.filterChangeEvent.emit(filterMetadata);
      }
    });
  },
};
